import Model from "./Model";
import ListItemModel from "./ListItemModel";
import QuestionModel from './QuestionModel';
import ArticleModel from './ArticleModel';
import VideoModel from './VideoModel';

export default class ListModel extends Model {
  id: number;
  name: string;
  description: string;
  type: string;
  author: string;
  publishDate: string;

  static __typename: string = 'List';
  static __types: string[] = [
    'ARTICLE',
    'EXERCISES',
    'LESSON',
    'STUDY_CASE',
    'SUPPORT_MATERIAL',
    'QUIZ',
    'APPOSTILA',
    'WEEKLY_EVALUATION',
    'REVIEW_LIST'
  ];

  constructor(list: any, getters: any) {
    super(getters);
    this.id = list.id;
    this.name = list.name;
    this.description = list.description;
    this.type = list.type;
    this.author = list.author;
    this.publishDate = list.publishDate;
  }

  listItems(): ListItemModel[] {
    return this.getters
      .listItemsByListId(this.id)
      .concat()
      .sort((A:ListItemModel, B:ListItemModel) => A.position - B.position)
  }
  
  questions(): QuestionModel[] {
    return this.listItems()
      .filter((listItem: ListItemModel) => listItem.questionId)
      .map((listItem: ListItemModel) => this.getters.questionById(listItem.questionId));
  }

  articles(): ArticleModel[] {
    return this.listItems()
      .filter((listItem: ListItemModel) => listItem.articleId)
      .map((listItem: ListItemModel) => this.getters.articleById(listItem.articleId));
  }

  videos(): VideoModel[] {
    return this.listItems()
      .filter((listItem: ListItemModel) => listItem.videoId)
      .map((listItem: ListItemModel) => this.getters.videoByVideoId(listItem.videoId));
  }

  raw() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      type: this.type,
      author: this.author,
      publishDate: this.publishDate,
      __typename: ListModel.__typename,
      __types: ListModel.__types,
    }
  }
}